import { currencyFormatter, currencyFormatterPreventPropagation, customThousandSeparatorDot } from "../functions/general"
import { usePipelineStore } from "../stores/PipelineStore"

interface UseHandleChangeProductProps {
    setIsTotal?: (isTotal: boolean) => void
    setValueInputProduct?: (value: string) => void
    setQtyProduct?: (qtyProduct: string) => void
    setVatProduct?: (vatProduct: string) => void
}

const useHandleChangeProduct = ({ setIsTotal, setValueInputProduct, setQtyProduct, setVatProduct }: UseHandleChangeProductProps) => { // di gunakan pada inputan product handleHppChange, handleNominalChange, handlePriceChange, handleDiscountChange
    const { selectMultiPipeline } = usePipelineStore()

    const handleChangeProduct = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsTotal?.(false)
        const value = e.target.value ?? 0;
        const formattedValue = currencyFormatter(value, selectMultiPipeline.currencyIsRounded);
        const currencyFormatterValidation = currencyFormatterPreventPropagation(value);
        if (currencyFormatterValidation.hasTrailingMultipleDot) return void 0
        if (currencyFormatterValidation.hasTrailingDot || currencyFormatterValidation.hasTrailingDotZero) {
            return setValueInputProduct?.(value)
        }
        setValueInputProduct?.(formattedValue);
    }

    const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsTotal?.(false)
        const value = e.target.value ?? 0;
        const formattedValue = customThousandSeparatorDot(value)
        setQtyProduct?.(formattedValue);
    }

    const handleVatChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsTotal?.(false)
        const value = e.target.value ?? 0;
        if (!isNaN(Number(value)) && Number(value) > 100) {
            return;
        }
        const formattedValue = currencyFormatter(value, true);

        setVatProduct?.(formattedValue);
    }

    return {
        handleChangeProduct,
        handleQtyChange,
        handleVatChange
    }
}

export default useHandleChangeProduct;